import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { FiMessageCircle, FiAlertTriangle, FiAlertCircle, FiInfo } from 'react-icons/fi';
import { getPriorityClass } from '../data/notificationsData';

const CityNotificationsList = () => {
  const { cityNotifications, markAsRead, markCurrentServiceAsRead } = useNotifications();

  // Show empty state if no notifications
  if (cityNotifications.length === 0) {
    return (
      <div className="empty-state">
        <FiMessageCircle className="empty-icon" />
        <h3 className="empty-title">No Notifications</h3>
        <p className="empty-description">
          There are no notifications for this city.
        </p>
      </div>
    );
  }

  // Format date to display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }
  };

  // Format category label
  const formatCategory = (category) => {
    return category.charAt(0).toUpperCase() + category.slice(1);
  };

  // Get priority icon
  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'emergency':
        return <FiAlertTriangle className="priority-icon priority-icon-emergency" aria-label="Emergency" />;
      case 'important':
        return <FiAlertCircle className="priority-icon priority-icon-important" aria-label="Important" />;
      default:
        return <FiInfo className="priority-icon priority-icon-standard" aria-label="Information" />;
    }
  };

  // Get priority text
  const getPriorityText = (priority) => {
    switch (priority) {
      case 'emergency':
        return 'URGENT';
      case 'important':
        return 'IMPORTANT';
      default:
        return '';
    }
  };

  return (
    <div className="city-notifications-list">
      {cityNotifications.some(notification => !notification.read) && (
        <button
          className="mark-all-button"
          onClick={markCurrentServiceAsRead}
        >
          Mark all as read
        </button>
      )}

      {cityNotifications.map((notification) => (
        <div
          key={notification.id}
          className={`notification-item ${notification.read ? 'notification-read' : ''} ${getPriorityClass(notification.priority)}`}
          role="article"
          aria-label={`${notification.priority === 'emergency' ? 'Emergency' : notification.priority === 'important' ? 'Important' : ''} ${notification.category} notification`}
        >
          <span className={`category-label-corner ${notification.category}`}>
            {formatCategory(notification.category)}
          </span>
          <div className="notification-content">
            <div className="notification-header">
              <div className="notification-title-row">
                {getPriorityIcon(notification.priority)}
                <h3 className="notification-title">
                  {getPriorityText(notification.priority) && (
                    <span className="priority-text">{getPriorityText(notification.priority)}: </span>
                  )}
                  {notification.title}
                </h3>
              </div>
              <span className="notification-time">
                {formatDate(notification.date)} {notification.time}
              </span>
            </div>
            <div className="notification-service">{notification.serviceName}</div>
            <p className="notification-description">{notification.description}</p>
            {!notification.read && (
              <div className="notification-action">
                <button onClick={() => markAsRead(notification.id)}>
                  Mark as read
                </button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CityNotificationsList;